module.exports = __webpack_public_path__ + "static/img/banner002.6749869.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner002.jpg
// module id = Ac2m
// module chunks = 15